<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />
            </div>

            <div class="right-items">
                <a-input-search placeholder="搜索订单号" enter-button @search="on_search" class="item" v-model="wd" />
            </div>
        </div>

        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="order_no"
                :loading="loading"
                :pagination="pagination"
                @change="on_pagination_change"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
                size="middle"
            >
                <!-- 创建时间 -->
                <template slot="created" slot-scope="text, record">
                    <div class="tbox">
                        <div class="a">{{ text.name }}</div>
                        <div class="b">{{ moment(record.created_at * 1000).format("MM-DD HH:mm") }}</div>
                    </div>
                </template>

                <template slot="member" slot-scope="text">
                    <div class="tbox" v-if="text">
                        <div class="a">{{ text.name }}</div>
                        <div class="b">ID：{{ text.id }}</div>
                    </div>
                </template>

                <template slot="seller" slot-scope="text">
                    <div class="tbox" v-if="text">
                        <div class="a">{{ text.name }}</div>
                        <div class="b">ID：{{ text.id }}</div>
                    </div>
                </template>

                <!-- 备注 -->
                <template slot="remark" slot-scope="text">
                    <div class="remark">
                        {{ text }}
                    </div>
                </template>

                <!-- 店铺编号 -->
                <template slot="trademark" slot-scope="text">
                    <div class="trademark">
                        <div class="thumb"><img :src="text.logo" /></div>
                        <div class="detail">
                            <div class="name">{{ text.markName }}</div>
                            <div class="id">{{ text.applyNo }}</div>
                        </div>
                    </div>
                </template>

                <template slot="action" slot-scope="text, record">
                    <a-button size="small" @click="on_generate(record)">生成订单</a-button>
                </template>
            </a-table>
        </div>

        <!-- 创建订单 -->
        <modal_generate :visible="visible_generate" :callback="load" @close="visible_generate = false" :record="selected_record"/>
    </div>
</template>

<script>
    import moment from "moment";
    import common_pagination from "../../../mixins/common_pagination.js";
    import commonjs from "../mixins/common";
    import modal_generate from "./modal_generate.vue";

    export default {
        mixins: [common_pagination, commonjs],
        components: { modal_generate },
        data() {
            return {
                path: "/order/accept",
                data_source: [],
                loading: false,
                visible_generate: false,
                selected_record: null,
                type: "",
                wd: null,
                columns: [
                    {
                        dataIndex: "order_no",
                        width: 190,
                        title: "订单号",
                    },
                    {
                        dataIndex: "trademark",
                        title: "商标信息",
                        width: 220,
                        scopedSlots: {
                            customRender: "trademark",
                        },
                    },
                    {
                        dataIndex: "amount",
                        title: "订单金额",
                        width: 100,
                        customRender: (e) => `¥ ${e || "-"}`,
                    },
                    {
                        dataIndex: "mediator.name",
                        title: "媒介",
                        width: 120,
                    },
                    {
                        dataIndex: "user",
                        title: "创建时间",
                        width: 120,
                        scopedSlots: {
                            customRender: "created",
                        },
                    },
                    {
                        dataIndex: "remark",
                        title: "备注",
                        scopedSlots: {
                            customRender: "remark",
                        },
                    },
                    {
                        dataIndex: "action",
                        title: "操作",
                        width: 120,
                        align: "center",
                        scopedSlots: {
                            customRender: "action",
                        },
                    },
                ],
            };
        },
        mounted() {},
        watch: {
            $route() {
                this.load();
                this.reset_query();
            },
        },
        created() {
            this.load();
            this.reset_query();
            this.$store.commit("change_state", {
                name: "sidebar_order",
                value: "accept",
            });
        },
        methods: {
            moment,
            reset_query() {
                let query = this.$route.query;

                if (Object.prototype.hasOwnProperty.call(query, "wd")) {
                    this.wd = query["wd"];
                } else {
                    this.wd = "";
                }

                if (Object.prototype.hasOwnProperty.call(query, "type")) {
                    this.type = query["type"];
                } else {
                    this.type = "";
                }
            },
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/order_trademark/prepare/accept?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            on_generate(record) {
                this.selected_record = record;
                this.visible_generate = true;
            },
            on_status_change(e) {
                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                new_query["status"] = e.target.value;
                this.$router.push(this.path + "?" + this.objectToQuery(new_query));
            },
        },
    };
</script>

<style lang="less" scoped>
    .container {
        .action {
            width: 120px;
        }
        .sort {
            display: flex;
            justify-content: space-around;
        }
        .order {
            .description {
                font-size: 12px;
                color: #00000080;
            }
        }
        .trademark {
            display: flex;
            align-items: center;
            .thumb {
                width: 50px;
                height: 50px;
                margin-right: 8px;
                img {
                    width: 100%;
                }
            }
            .detail {
                .name {
                    font-size: 14px;
                    font-weight: bold;
                }
                .id {
                    font-size: 12px;
                }
            }
        }

        .remark {
            font-size: 12px;
        }
    }
</style>
